import { Primitive } from '../../../../types/blocks/Primitive';

/**
 * @deprecated use PropertyInputBlock instead
 */
const FileInputBlock: Primitive = {
  name: 'FileInputBlock',
  friendlyName: 'File Upload',
  isInput: true,
  isPrimitive: true,
  properties: {
    file: {
      type: 'Media',
      validators: [
        {
          name: 'Required',
          value: true,
        },
      ],
    },
    disabled: {
      type: 'Boolean',
      default: false,
    },
    fileTypes: {
      type: 'String',
      isArray: true,
      validators: [
        {
          name: 'ArrayMax',
          value: 8,
        },
        {
          name: 'ArrayMin',
          value: 1,
        },
        {
          name: 'In',
          // todo: put in more valid file types.
          // @ts-expect-error ts-migrate(2322) FIXME: Type '{ name: "In"; values: string[]; }' is not as... Remove this comment to see the full error message
          values: ['application/pdf', 'application/docx'],
        },
      ],
    },
  },
  publishes: {
    // @ts-expect-error ts-migrate(2741) FIXME: Property 'action' is missing in type '{ type: "Eve... Remove this comment to see the full error message
    input: {
      type: 'Event',
    },
    // @ts-expect-error ts-migrate(2741) FIXME: Property 'action' is missing in type '{ type: "Eve... Remove this comment to see the full error message
    click: {
      type: 'Event',
    },
  },
};

export default FileInputBlock;
